import dayjs from "dayjs"

/** 格式化时间 */
export const formatDateTime = (time: any) => {
  if (time == null || time === "") {
    return "N/A"
  }
  const date = new Date(time)
  return dayjs(date).format("YYYY-MM-DD HH:mm:ss")
}

// 字符串转json
export const str2JSON = (str: string | null) => {
  if (!str) {
    console.log("str转json失败，字符串为空")
    return null
  }
  try {
    return JSON.parse(str)
  } catch (e) {
    try {
      str = str2jsonStr(str)
      return JSON.parse(str)
    } catch (e) {
      console.log(`字符串'${str}'转json失败`, e)
      return null
    }
  }
}

const str2jsonStr = (str: string) => {
  str = str.replace("{", '{"')
  str = str.replace(":", '":"')
  str = str.replace(",", '","')
  str = str.replace("}", '"}')
  return str
}
